<template>
    <div :class="[appearance ? `${appearance}` : '', 'heroImage']">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'WidgetHeroImage',
    props: {
        appearance: {
            type: String,
            required: false,
            default: null,
        },
    },
};
</script>
